<div class="popup-container">
  <div class="container">
    <h2>Details</h2>
  <table mat-table [dataSource]="positions">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let position">{{ position.name }}</td>
    </ng-container>

    <ng-container matColumnDef="itemPrice">
      <th mat-header-cell *matHeaderCellDef>Preis</th>
      <td mat-cell *matCellDef="let position">{{ position.itemPrice | currency: 'EUR': 'symbol' }}</td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>Menge</th>
      <td mat-cell *matCellDef="let position">{{ position.quantity }}</td>
    </ng-container>

    <ng-container matColumnDef="cancelledQuantityRequested">
      <th mat-header-cell *matHeaderCellDef>stornierte Menge (Kellner)</th>
      <td mat-cell *matCellDef="let position">{{ position.cancelledQuantityRequested }}</td>
    </ng-container>

    <ng-container matColumnDef="cancelledQuantityAccepted">
      <th mat-header-cell *matHeaderCellDef>stornierte Menge (akzeptiert)</th>
      <td mat-cell *matCellDef="let position">{{ position.cancelledQuantityAccepted }}</td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Summe</th>
      <td mat-cell *matCellDef="let position">{{ position.itemPrice * position.quantity | currency: 'EUR': 'symbol' }}</td>
    </ng-container>

    <ng-container matColumnDef="cancelPosition">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let position">
        <button mat-button color="warn" (click)="cancelPosition(position)" [disabled]="position.quantity <= position.cancelledQuantityRequested">Pos 1x stornieren</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let position; columns: displayedColumns;"></tr>
  </table>
  </div>
</div>
